import { z } from "zod";

import type { CoordsType } from "~/lib/map/types";

const zExpectedCoords = z.object({
  type: z.literal("Point"),
  coordinates: z.tuple([z.number(), z.number()]),
});

export const parseCoords = (coords: unknown): CoordsType => {
  const parsed = zExpectedCoords.parse(coords);
  return {
    lat: parsed.coordinates[1],
    lng: parsed.coordinates[0],
  };
};
